/**
 * Checks if a product is in the object types.
 *
 * @param {Array} objectTypes to check
 * @return {boolean} Whether the object types contains product
 */
export const isSearchingForProducts = objectTypes => {
	return objectTypes.includes( 'product' );
};
